import * as THREE from "three";
import {
  SPOT_COLOR_DEFAULT,
  SPOT_INTENSITY_DEFAULT,
  SPOT_DISTANCE_DEFAULT,
  SPOT_ANGLE_DEFAULT,
  SPOT_PENUMBRA_DEFAULT,
  SPOT_DECAY_DEFAULT,
  SPOT_POSITION_X_DEFAULT,
  SPOT_POSITION_Y_DEFAULT,
  SPOT_POSITION_Z_DEFAULT,
  SPOT_IS_VISIBLE_DEFAULT,
  IS_SPOT_LIGHT_CAST_SHADOWS,
  SPOT_LIGHT_SHADOWS_HEIGHT_DEFAULT,
  SPOT_LIGHT_SHADOWS_WIDTH_DEFAULT,
} from "../../config";

export const sportLightFactory = () => {
  const spotLight = new THREE.SpotLight(
    SPOT_COLOR_DEFAULT,
    SPOT_INTENSITY_DEFAULT,
    SPOT_DISTANCE_DEFAULT,
    SPOT_ANGLE_DEFAULT,
    SPOT_PENUMBRA_DEFAULT,
    SPOT_DECAY_DEFAULT
  );
  spotLight.position.set(
    SPOT_POSITION_X_DEFAULT,
    SPOT_POSITION_Y_DEFAULT,
    SPOT_POSITION_Z_DEFAULT
  );
  spotLight.visible = SPOT_IS_VISIBLE_DEFAULT;
  spotLight.castShadow = IS_SPOT_LIGHT_CAST_SHADOWS;
  spotLight.shadow.mapSize.width = SPOT_LIGHT_SHADOWS_WIDTH_DEFAULT;
  spotLight.shadow.mapSize.height = SPOT_LIGHT_SHADOWS_HEIGHT_DEFAULT;

  return [spotLight, spotLight.target];
};
